import axiosV1 from "@/plugins/axios/configV1";

export default {
    addPromo(...payload) {
        return axiosV1.post("promos", ...payload);
    },
    updatePromo(id, ...payload) {
        return axiosV1.post(`promos/update/${id}`, ...payload);
    },
    getPromos(params) {
        return axiosV1.get(`promos`, { params });
    },
    exportExcel(params) {
        return axiosV1.get(`promos/export`, { params });
    },
    acivatePromo(id = null) {
        return axiosV1.post(`promos/activate/${id}`);
    },
    acivatePromoAll(ids) {
        return axiosV1.post(`promos/bulk/activate`, ids);
    },
    onHoldPromo(id = null, reason = "") {
        return axiosV1.post(`promos/on-hold/${id}`, { reason });
    },
    getPromo(id = null) {
        return axiosV1.get(`promos/view/${id}`);
    },
    getPromoHistory(id = null, ...params) {
        return axiosV1.get(`promos/view/history/${id}`, ...params);
    },
    getPromoParticipatingModel(id = null, params) {
        return axiosV1.get(`promos/view/models/${id}`, { params });
    },
    addBudget(id, ...payload) {
        return axiosV1.post(`promos/add-budget/${id}`, ...payload);
    },
    getFormParticipatingModel(params) {
        return axiosV1.get(`promos/fetch/models`, { params });
    },
    importModels(file = null, budget = {}) {
        const budgetType =
            budget.hasCamera && budget.hasPrinter
                ? "3"
                : budget.hasPrinter
                ? "2"
                : "1";

        let formData = new FormData();
        formData.append("file", file);
        formData.append("budget", budgetType);

        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post(`promos/import/models`, formData);
    },
    mergeModels(...payload) {
        return axiosV1.post(`promos/merge/models`, ...payload);
    },
    importPromo(file = null) {
        let formData = new FormData();
        formData.append("file", file);
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post(`promos/import`, formData);
    },

    // Adds
    async getAds(params) {
      // return axiosV1.get(`products/pins`, { params });
      await new Promise(resolve => setTimeout(resolve, 1000));

      return Promise.resolve({
        data: {
          service_centers: {
            total: 10,
            last_page: 20,
            data: [
              { id: 1, title: 'Canon be smart print smart ad times of India delhi', date_created: 'Sept 20, 2022 11:00 AM', status: 2 },
              { id: 2, title: 'Canon be smart print smart ad times of India delhi', date_created: 'Sept 20, 2022 11:00 AM', status: 3 },
              { id: 3, title: 'Canon be smart print smart ad times of India delhi', date_created: 'Sept 20, 2022 11:00 AM', status: 1 },
              { id: 4, title: 'Canon be smart print smart ad times of India delhi', date_created: 'Sept 20, 2022 11:00 AM', status: 1 },
              { id: 5, title: 'Canon be smart print smart ad times of India delhi', date_created: 'Sept 20, 2022 11:00 AM', status: 1 },
            ]
          }
          
        }
      }) 
    },
};
